import React from "react";
import { Link } from "react-router-dom";
import { Mail, Calendar, ArrowRight } from "lucide-react";
import { FOOTER } from "@/constants/testIds";
import Logo from "@/components/site/Logo";

const Footer = () => {
    return (
        <footer
            data-testid={FOOTER.root}
            className="bg-indigo_brand text-white mt-12"
        >
            {/* Pre-footer CTA band */}
            <div className="border-b border-white/10">
                <div className="ih-container py-16 md:py-20 grid gap-10 lg:grid-cols-[1.4fr_1fr] lg:items-center">
                    <div>
                            <p
                                className="ih-eyebrow"
                                style={{ color: "#08C020" }}
                            >
                            Start Where It Matters
                        </p>
                            <h3 className="mt-3 text-3xl sm:text-4xl text-white font-montserrat font-bold leading-tight">
                            See your organization&rsquo;s HUMAN+ Readiness
                            <span className="block text-green_brand">
                                in under 10 minutes.
                            </span>
                        </h3>
                        <p className="mt-5 text-white/80 font-opensans text-base max-w-xl">
                            Take the free HUMAN+ Snapshot™ and receive a
                            personalized Executive Report with your six-pillar
                            scorecard, strengths, and growth opportunities.
                        </p>
                    </div>
                    <div className="flex flex-col sm:flex-row lg:flex-col gap-3 lg:items-end">
                        <Link
                            to="/snapshot"
                            data-testid={FOOTER.snapshotCta}
                            className="ih-btn-primary"
                        >
                            Take the Snapshot
                            <ArrowRight size={16} />
                        </Link>
                        <Link
                            to="/discovery"
                            data-testid={FOOTER.discoveryCta}
                            className="font-poppins font-medium text-sm uppercase tracking-[0.12em] text-white border border-white/40 hover:bg-white/10 px-7 py-[0.9rem] rounded-lg inline-flex items-center gap-2 transition"
                        >
                            <Calendar size={16} />
                            Schedule a Discovery Call
                        </Link>
                    </div>
                </div>
            </div>

            {/* Footer body */}
            <div className="ih-container py-14 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
                <div>
                    <Logo variant="light" />
                    <p className="mt-5 text-white/70 font-opensans text-sm leading-relaxed">
                        Research-informed consulting that helps organizations
                        adopt AI while strengthening the human capabilities
                        technology cannot replace.
                    </p>
                </div>

                <div>
                    <p className="font-raleway font-semibold text-white text-sm uppercase tracking-[0.16em]">
                        Explore
                    </p>
                    <ul className="mt-5 space-y-3 font-opensans text-sm">
                        <li><Link to="/" className="text-white/75 hover:text-green_brand transition">Home</Link></li>
                        <li><Link to="/about" className="text-white/75 hover:text-green_brand transition">About</Link></li>
                        <li><Link to="/framework" className="text-white/75 hover:text-green_brand transition">HUMAN+ Framework™</Link></li>
                        <li><Link to="/resources" className="text-white/75 hover:text-green_brand transition">Resources</Link></li>
                    </ul>
                </div>

                <div>
                    <p className="font-raleway font-semibold text-white text-sm uppercase tracking-[0.16em]">
                        Engage
                    </p>
                    <ul className="mt-5 space-y-3 font-opensans text-sm">
                        <li><Link to="/snapshot" className="text-white/75 hover:text-green_brand transition">HUMAN+ Snapshot™</Link></li>
                        <li><Link to="/foundations" className="text-white/75 hover:text-green_brand transition">Foundations Experience™</Link></li>
                        <li><Link to="/workshop" className="text-white/75 hover:text-green_brand transition">Snapshot Workshop</Link></li>
                        <li><Link to="/discovery" className="text-white/75 hover:text-green_brand transition">Discovery Call</Link></li>
                        <li><Link to="/contact" className="text-white/75 hover:text-green_brand transition">Contact</Link></li>
                    </ul>
                </div>

                <div>
                    <p className="font-raleway font-semibold text-white text-sm uppercase tracking-[0.16em]">
                        Contact
                    </p>
                    <a
                        href="mailto:info@theintuitushub.com"
                        data-testid={FOOTER.contactCta}
                        className="mt-5 inline-flex items-center gap-2 text-white/75 hover:text-green_brand font-opensans text-sm transition"
                    >
                        <Mail size={15} />
                        info@theintuitushub.com
                    </a>
                    <p className="mt-6 text-white/55 font-opensans text-xs leading-relaxed max-w-xs">
                        For executives, HR leaders, and organizations preparing
                        for an AI-enabled future.
                    </p>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="ih-container py-6 flex flex-col md:flex-row gap-3 md:items-center md:justify-between">
                    <p className="text-white/55 font-opensans text-xs">
                        © {new Date().getFullYear()} The Intuitus Hub™. All
                        rights reserved.
                    </p>
                    <p className="text-white/45 font-opensans text-xs">
                        HUMAN+ Framework™ · HUMAN+ Snapshot™ · HUMAN+ Foundations
                        Experience™
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
